// import React, { useRef } from "react";
// import styled from "styled-components";
// import QRCode from "react-qr-code";
// import logo from "../Images/texastrashcanlogo.jpeg";
// import html2canvas from "html2canvas";
// import jsPDF from "jspdf";

// const TexasTrashCanFlyer2 = () => {
//   const qrLink = "https://texastrashcanvalet.com/sign-up-8981";
//   const flyerRef = useRef(null);

//   const downloadFlyer = () => {
//     html2canvas(flyerRef.current, { scale: 2 }).then((canvas) => {
//       const imgData = canvas.toDataURL("image/png");
//       const pdf = new jsPDF("p", "mm", "a4");
//       const imgProps = pdf.getImageProperties(imgData);
//       const pdfWidth = pdf.internal.pageSize.getWidth();
//       const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
//       pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
//       pdf.save("TexasTrashCanFlyer2.pdf");
//     });
//   };

//   return (
//     <FlyerContainer ref={flyerRef}>
//       <SidePanel>
//         <Logo src={logo} />
//         <QRCode value={qrLink} size={100} />
//         <SideText>Scan to sign up in seconds with 1 week free trial.</SideText>
//         <SideCTA href={qrLink}>https://texastrashcanvalet.com/sign-up-8981</SideCTA>
//         <Phone>📞 +1 (915) 856-2134</Phone>
//       </SidePanel>

//       <MainContent>
//         <MainHeadline>Trash Day? Never Miss It Again.</MainHeadline>
//         <SubText>Your bins, our responsibility — let us do the hauling.</SubText>

//         <Benefits>
//           <li>✔ Weekly reliable valet service</li>
//           <li>✔ Elderly- & HOA-friendly</li>
//           <li>✔ 100% locally owned</li>
//         </Benefits>

//         <Plans>
//           <Plan>
//             <h3>Standard — $39/mo</h3>
//             <ul>
//               <li>Weekly pickup & return</li>
//               <li>2 cans • 1-week free trial</li>
//               <li>Bin Cleaning available at extra price per bin.</li>
//               <li>Cancel anytime</li>
//             </ul>
//           </Plan>
//           <Plan>
//             <h3>Premium — $49/mo</h3>
//             <ul>
//               <li>Twice-weekly valet</li>
//               <li>Up to 4 cans • Free trial</li>
//               <li>Quarterly bin cleaning</li>
//               <li>No contracts</li>
//             </ul>
//           </Plan>
//         </Plans>

//         <CustomNote>
//           🏘 Managing 10+ homes? We offer flexible pricing for neighborhoods & HOAs.
//         </CustomNote>

//         <Download onClick={downloadFlyer}>Download</Download>
//       </MainContent>
//     </FlyerContainer>
//   );
// };

// export default TexasTrashCanFlyer2;

// // ---------------- Styled Components ----------------

// const FlyerContainer = styled.div`
//   display: flex;
//   height: auto;
//   max-width: 900px;
//   margin: 2rem auto;
//   box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
//   font-family: "Segoe UI", sans-serif;
//   overflow: hidden; 
//   background: #ffffff;
// `;

// const SidePanel = styled.div`
//   background: #002f4b;
//   color: #fff;
//   width: 240px;
//   padding: 2rem;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: space-between;
// `;

// const Logo = styled.img`
//   width: 80px;
//   border-radius: 20px;
//   margin-bottom: 1rem;
// `;

// const SideText = styled.div`
//   margin-top: 1rem;
//   font-size: 0.9rem;
//   text-align: center;
// `;

// const SideCTA = styled.a`
//   margin-top: 1.2rem;
//   font-size: 0.8rem;
//   color: #90ee90;
//   text-align: center;
//   text-decoration: underline;
// `;

// const Phone = styled.div`
//   font-size: 0.85rem;
//   margin-top: 1rem;
// `;

// const MainContent = styled.div`
//   flex: 1;
//   padding: 2rem 3rem;
//   position: relative;
//   background: linear-gradient(120deg, #e6ffe6, #f0fff0);
// `;

// const MainHeadline = styled.h1`
//   font-size: 1.8rem;
//   color: #003b3b;
//   margin-bottom: 0.5rem;
// `;

// const SubText = styled.div`
//   font-size: 1rem;
//   color: #111;
//   margin-bottom: 1.5rem;
// `;

// const Benefits = styled.ul`
//   list-style: none;
//   padding: 0;
//   margin-bottom: 1.8rem;
//   font-size: 0.95rem;

//   li {
//     margin-bottom: 0.5rem;
//   }
// `;

// const Plans = styled.div`
//   display: flex;
//   gap: 1.5rem;
//   margin-bottom: 1.2rem;
// `;

// const Plan = styled.div`
//   background: #fff;
//   padding: 1rem;
//   border-left: 5px solid #66bb6a;
//   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
//   border-radius: 8px;
//   width: 50%;

//   h3 {
//     font-size: 1rem;
//     margin-bottom: 0.5rem;
//     color: #004d40;
//   }

//   ul {
//     padding-left: 1rem;
//     font-size: 0.85rem;
//     color: #111;
//   }
// `;

// const CustomNote = styled.div`
//   font-size: 0.85rem;
//   margin-top: 1rem;
//   font-style: italic;
//   color: #111;
//   font-weight:bold;
// `;

// const Download = styled.button`
//    margin-top: 2rem;
// border: none;
//   color: rgba(255,255,255,0.0);
//   padding: 0.8rem 1.3rem;
//   border-radius: 8px;
//   font-weight: 600;
//   cursor: pointer;
//   transition: background-color 0.3s ease;
//   position:absolute;
//   bottom:0;
//   right:0;
//   background:none;

  

 
// `;






import React, { useRef } from "react";
import styled from "styled-components";
import QRCode from "react-qr-code";
import logo from "../Images/texastrashcanlogo.jpeg";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const TexasTrashCanFlyer2 = () => {
  const qrLink = "https://texastrashcanvalet.com/sign-up-8981";
  const flyerRef = useRef(null);

  const downloadFlyer = () => {
    html2canvas(flyerRef.current, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("TexasTrashCanFlyer2.pdf");
    });
  };

  return (
    <FlyerContainer ref={flyerRef}>
      <SidePanel>
        <Logo src={logo} />
        <QRCode value={qrLink} size={100} />
        <SideText>Scan to sign up in seconds with 1 week free trial.</SideText>
        <SideCTA href={qrLink}>https://texastrashcanvalet.com/sign-up-8981</SideCTA>
        <Phone>📞 +1 (915) 856-2134</Phone>
      </SidePanel>

      <MainContent>
        <MainHeadline>Trash Day? Never Miss It Again.</MainHeadline>
        <SubText>Your bins, our responsibility — let us do the hauling.</SubText>

        <Benefits>
          <li>✔ Weekly reliable valet service</li>
          <li>✔ Elderly- & HOA-friendly</li>
          <li>✔ 100% locally owned</li>
        </Benefits>

  <Div>
    <h5>-- Monthly Plans. Billed Monthly --</h5>
  <Plans>
  <Plan>
    <h3>Starter - $49/mo</h3>
    <span>
      <p> Up to 2 cans</p>
      <p> 1 collection per week</p>
      <p> Success manager & support</p>
    </span>
    
  </Plan>

  <Plan>
    <h3>Premium - $65/mo</h3>
    <span>
      <p> Up to 4 cans</p>   
      <p> Up to 2 collections per week</p>
      <p>Success manager & support</p>
    </span>
  </Plan>

  <Plan>
    <h3>Business - $75/mo</h3>
    <span>
      <p> Up to 6 cans</p>
      <p> Up to 2 collections per week</p>
      <p> Success manager & support</p>
    </span>

  </Plan>

  <Plan>
    <h3>Enterprise - Custom</h3>
    <span>
      <p> For 10+ properties</p>
      <p> Custom billing</p>
     
      <p>Dedicated success manager</p>
    </span>
    <span style={{fontWeight:"bold"
    }}>Contact Us!</span>
  </Plan>
</Plans>
  </Div>    



<Div>
    <h5>-- Quaterly Plans. Billed Quarterly --</h5>
<Plans>
    
    <Plan>
      <h3>Starter - $39/mo</h3>
      <span>
        <p>Up to 2 cans</p>
        <p>1 collection per week</p>
 
        <p>Success manager & support</p>
      </span>
      <span>* Billed quarterly</span>
    </Plan>
  
    <Plan>
      <h3>Premium - $54/mo</h3>
      <span>
        <p>Up to 4 cans</p>
        <p>Up to 2 collections per week</p>
        <p>Success manager & support</p>
      </span>
      <span>* Billed quarterly</span>
    </Plan>
  
    <Plan>
      <h3>Business - $65/mo</h3>
      <span>
        <p>Up to 6 cans</p>
        <p>Up to 2 collections per week</p>
        <p>Success manager & support</p>
      </span>
      <span>* Billed quarterly</span>
    </Plan>
  
    <Plan>
      <h3>Enterprise - Custom</h3>
      <span>
        <p>For 10+ properties</p>
        <p>Custom billing</p>
        <p>Dedicated success manager</p>
      </span>   
      <span style={{fontWeight:"bold"}}>Contact Us!</span>
    </Plan>
  </Plans>
</Div>





        {/* <CustomNote>
          🏘 Managing 10+ homes? We offer flexible pricing for neighborhoods & HOAs.
        </CustomNote> */}

        <Download onClick={downloadFlyer}>Download</Download>
      </MainContent>
    </FlyerContainer>
  );
};

export default TexasTrashCanFlyer2;

// ---------------- Styled Components ----------------

const FlyerContainer = styled.div`
  display: flex;
  height: auto;
  max-width: 900px;
  margin: 2rem auto;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
  font-family: "Segoe UI", sans-serif;
  overflow: hidden; 
  background: #ffffff;
`;

const SidePanel = styled.div`
  background: #002f4b;
  color: #fff;
  width: 240px;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

const Logo = styled.img`
  width: 80px;
  border-radius: 20px;
  margin-bottom: 1rem;
`;

const SideText = styled.div`
  margin-top: 1rem;
  font-size: 0.9rem;
  text-align: center;
`;

const SideCTA = styled.a`
  margin-top: 1.2rem;
  font-size: 0.8rem;
  color: #90ee90;
  text-align: center;
  text-decoration: underline;
`;

const Phone = styled.div`
  font-size: 0.85rem;
  margin-top: 1rem;
`;

const MainContent = styled.div`
  flex: 1;
  padding: 2rem 0.5rem;
  position: relative;
  background: linear-gradient(120deg, #e6ffe6, #f0fff0);
`;

const MainHeadline = styled.h1`
  font-size: 1.8rem;
  color: #003b3b;
  margin-bottom: 0.5rem;
  padding-left:20px;
`;

const SubText = styled.div`
  font-size: 1rem;
  color: #111;
  margin-bottom: 1.5rem;
  padding-left:20px;
`;

const Benefits = styled.ul`
  list-style: none;
  padding: 0;
  margin-bottom: 1.8rem;
  font-size: 0.95rem;
  padding-left:20px;

  li {
    margin-bottom: 0.5rem;
  }
`;


const Div = styled.div`
      display:flex;
      flex-direction:column;
      justify-content:center;
      align-items:center;
      gap:10px;
      font-style:italic;  
      color:#111;     
`

const Plans = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 1.2rem;
`;

const Plan = styled.div`
  background: #fff;
  padding: 5px;
  border-left: 5px solid #66bb6a;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  width: 50%;
  display:flex;
  flex-direction:column;
  justify-content:flex-start;
  align-items:flex-start;

  h3 {
    font-size: 0.9rem;
    margin-bottom: 0.5rem;
    color: #004d40;
  }

  span {
     
    font-size: 0.85rem;
    color: #111;
  }
`;

const CustomNote = styled.div`
  font-size: 0.85rem;
  margin-top: 1rem;
  font-style: italic;
  color: #111;
  font-weight:bold;
  padding-left:20px;
`;

const Download = styled.button`
   margin-top: 2rem;
border: none;
  color: rgba(255,255,255,0.0);
  padding: 0.8rem 1.3rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease;
  position:absolute;
  bottom:0;
  right:0;
  background:none;

  

 
`;
